import React from 'react';
// ---------------  For Ui ----------------------------------
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import { Redirect } from 'react-router-dom'
// ---------------  For Redux ----------------------------------
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { createForm, createFormReset } from './store/formActions'
import AddInput from './AddInput';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  layout: {
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      maxWidth: '90%', background: 'rgba(0,0,0,.1)',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    background: '#eee'
  },
  avatar: {
    margin: theme.spacing,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing,
  },
  submit: {
    marginTop: theme.spacing(3),
  },

});

const defaultValues = {
  id: '',
  title: '',
  defaultValue: '',
  isRequired: true,
  showOn: 'text'
}

class CreateForm extends React.Component {
  state = {
    formTitle: '',
    listTitle: '',
    firestorePath:'',//new
    addButtonTitle: 'Add',
    editButtonTitle: 'Edit',
    showToAdmin: false,
    inputCount: 2,
    inputValues: []
  }

  constructor(props) {
    super(props);

    const inputValues = [];
    for (let i = 0; i < this.state.inputCount; i++) {
      inputValues.push({ ...defaultValues });
    }
    this.state.inputValues = inputValues;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const data = { ...this.state };
    delete data.inputValues;

    const inputs = [];

    this.Refs.forEach((input) => {
      if(input && input.state)
        inputs.push({ ...input.state });
    })

    data.inputs = inputs;
    console.log("Create Form Data :", data)
    this.props.createForm(data)
  }

  addInput = () => {
    const { inputValues } = this.state;
    inputValues.push({ ...defaultValues });

    this.setState({ inputCount: this.state.inputCount + 1, inputValues })
  }

  deleteInput = (index) => {
    const { inputValues, inputCount } = this.state;

    this.setState({
      inputCount: inputCount - 1,
      inputValues: inputValues.splice(index, 1)
    })
    this.Refs.splice(index, 1);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleToggle = (e) => {
    this.setState({
      [e.target.id]: !this.state[e.target.id]
    })
  }


  Refs = [];

  renderInputs = () => {
    const InputTypes = ['text', 'number', 'user-select', 'role-select', 'toggle']
    const showOnOptions = ['content', 'avatar-icon', 'avatar-title']
    const { inputValues, inputCount } = this.state;

    const allInputs = [];
    for (let i = 0; i < inputCount; i++) {
      allInputs.push(
        <Grid item xs={12} md={6} lg={4}>
          <AddInput ref={elem => this.Refs[i] = elem} key={'key' + i} {...inputValues[i]} count={i} InputTypes={InputTypes} showOnOptions={showOnOptions} deleteInput={this.deleteInput} />
        </Grid>)
    }

    return allInputs;
  }

  render() {
    const { classes, auth, formData, history, createFormReset } = this.props;
    const { form, error } = formData || {};


    if (form) {
      history.push('/forms');
      createFormReset();
      return null;
    }

    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper} square={false}>
            <Typography variant="h4">Create new form</Typography>
            <form className={classes.form} onSubmit={this.handleSubmit} >

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="formTitle">Form Title</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={this.state.formTitle}
                      id="formTitle" name="formTitle" autoComplete="text" autoFocus />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="listTitle">List Title</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={this.state.listTitle}
                      id="listTitle" name="listTitle" autoComplete="text" autoFocus />
                  </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="firestorePath">Firestore Path</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={this.state.firestorePath}
                      id="firestorePath" name="firestorePath" autoComplete="text" autoFocus />
                  </FormControl>
                  </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="addButtonTitle">Add Button Title</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={this.state.addButtonTitle}
                      id="addButtonTitle" name="addButtonTitle" autoComplete="text" autoFocus />
                  </FormControl></Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="editButtonTitle">Edit Button Title</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={this.state.editButtonTitle}
                      id="editButtonTitle" name="editButtonTitle" autoComplete="text" autoFocus />
                  </FormControl></Grid>
                <Grid item xs={12} md={6}>
                  <FormControl margin="normal" required fullWidth>
                    <FormControlLabel
                      control={<Switch id="showToAdmin" checked={this.state.showToAdmin} onChange={this.handleToggle} name="showToAdmin" />}
                      label="Show To Admin"
                    />
                  </FormControl>
                </Grid>

              </Grid>

              <Grid container spacing={3}>
                {this.renderInputs()}
              </Grid>

              <div style={{ maxWidth: 150, margin: 'auto' }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={this.addInput}
                >
                  Add New
                </Button>
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Create
            </Button>
              {error ? <div>  <br /> <Typography component="p" color="error" align="center"> {error.message}</Typography> </div> : null}
            </form>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createForm: (form) => dispatch(createForm(form)),
    createFormReset: () => dispatch(createFormReset())
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id
  const forms = state.firestore.data.forms
  const form = forms ? forms[id] : null

  return {
    auth: state.firebase.auth,
    formData: state.formReducer,
    form: { ...form, id }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    { collection: 'forms' }
  ])
)(withStyles(styles)(CreateForm));